/**
 * SPDX-FileCopyrightText: 2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * https://github.com/nextcloud/server/blob/208e38e84e1a07a49699aa90dc5b7272d24489f0/lib/private/Group/MetaData.php#L34
 */
export var GroupSorting;
(function (GroupSorting) {
    GroupSorting[GroupSorting["UserCount"] = 1] = "UserCount";
    GroupSorting[GroupSorting["GroupName"] = 2] = "GroupName";
})(GroupSorting || (GroupSorting = {}));
